<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu menuId="root-menu" [swipeGesture]="false" contentId="main-content" type="overlay">
      <ion-content>
        <ion-list class="ion-no-border">
          <ion-menu-toggle auto-hide="false">
            <ion-item [routerDirection]="'root'" [routerLink]="['']">
              <i class=""></i>
              <ion-label>
                {{ 'MENU.HOME' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          @if (targetGroup() || (currentLanguage() !== 'en' && currentLanguage() !== 'da')) {
            @for (article of articles(); track article) {
              <ion-menu-toggle auto-hide="false">
                <ion-item [routerDirection]="'forward'" [routerLink]="['/article/' + article.slug]">
                  <i class="{{ article.icon }} menu-icon"></i>
                  <ion-label>
                    {{ article.menutitle }}
                    @if (article.hasFilm) {
                      <i class="icon-play film-icon"></i>
                    }
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          } @else {
            <ion-menu-toggle auto-hide="false">
              <ion-item button (click)="setTargetGroup('pre-existing')">
                <i class="icon-pre-existing-diabetes menu-icon"></i>
                <ion-label>{{ 'INTRO.PRE_EXISTING' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle auto-hide="false">
              <ion-item button (click)="setTargetGroup('gestational')">
                <i class="icon-gestational-diabetes menu-icon"></i>
                <ion-label>{{ 'INTRO.GESTATIONAL' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
          @if (targetGroup() || (currentLanguage() !== 'en' && currentLanguage() !== 'da')) {
            <ion-menu-toggle auto-hide="false">
              <ion-item [routerDirection]="'forward'" [routerLink]="['/settings']">
                <i class="icon-settings menu-icon"></i>
                <ion-label>
                  {{ 'MENU.SETTINGS' | translate }}
                </ion-label>
              </ion-item>
            </ion-menu-toggle>
            @for (page of pages(); track page) {
              <ion-menu-toggle auto-hide="false">
                <ion-item [routerDirection]="'forward'" [routerLink]="['/page/' + page.slug]">
                  <i class="{{ page.icon }} menu-icon"></i>
                  <ion-label>
                    {{ page.menutitle }}
                  </ion-label>
                </ion-item>
              </ion-menu-toggle>
            }
          }
          @if (isWeb) {
            <ion-menu-toggle auto-hide="false">
              <ion-item [routerDirection]="'forward'" [routerLink]="['/download']">
                <i class="icon-health menu-icon"></i>
                <ion-label>{{ 'MENU.DOWNLOAD_APP' | translate }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          }
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content" />
  </ion-split-pane>
</ion-app>
